import { Component, OnInit, Input } from '@angular/core';
import { Investor } from '../../../shared/models/investor';

@Component({
  selector: 'app-asset-tab',
  templateUrl: './asset-tab.component.html',
  styleUrls: ['./asset-tab.component.css']
})
export class AssetTabComponent implements OnInit {

  activeAsset = '';
  assetTypes = availableAssetTypes;

  selectedAssets = [];
  totalAssetValue: number;
  totalReturnsValue: number;
  totalFinancialLiquidValue: number;

  @Input()
  investor: Investor;

  constructor() { }

  ngOnInit() {
  }

  activateAsset(asset) {
    if (asset === this.activeAsset) {
      this.activeAsset = '';
    } else {
      this.activeAsset = asset;
    }
  }

  selectAssetItem(asset) {
    // asset.value = 0;
    if (this.investor.assets.indexOf(asset) < 0) {
      this.investor.assets.push(asset);
      // console.log(asset.option_type);
      window.setTimeout(()=>{
        document.getElementById(asset.option_type).focus();
      }, 250);
    }
  }
  removeAsset(item) {
    this.investor.assets = this.investor.assets.filter(asset => asset !== item);
  }

  getTotalAssetsValue() {
    // tslint:disable-next-line:radix
    this.totalAssetValue = this.investor.assets.map(a => parseInt(a.value) || 0).reduce((val1, val2) => val1 + val2, 0);
    return this.totalAssetValue;
  }
  getTotalAssetsReturnsValue() {
    this.totalReturnsValue = this.investor.assets.map(a => (parseInt(a.value) || 0) * (a.return_percentage) / 100.0)
                                                 .reduce((val1, val2) => val1 + val2, 0);
    return this.totalReturnsValue;
  }

  getTotalFinancialLiquidValue() {
    this.totalFinancialLiquidValue = this.investor.assets.filter(a => a.asset_type === 'liquid' || a.asset_type === 'financial' || a.asset_type === 'marketable_instruments')
                                                          .map(a => parseInt(a.value) || 0).reduce((val1, val2) => val1 + val2, 0);
    return this.totalFinancialLiquidValue;
  }
  getTotalAssetsReturnsPercentage() {
    if (this.totalAssetValue != 0) {
      return this.totalReturnsValue / this.totalAssetValue * 100;
    } else {
      return "";
    }

  }
  // getTotalLiquidAssetsPercentage() {
  //   return this.totalFinancialLiquidValue / this.totalAssetValue * 100 || 0;
  // }

  update() {
    this.calculateAssetTotalValues();
  }

  calculateAssetTotalValues() {
    this.investor.total_financial_assets_value = this.calculateTotalAssetValueByType('financial');
    this.investor.total_liquid_assets_value = this.calculateTotalAssetValueByType('liquid');
    this.investor.total_tangile_assets_value = this.calculateTotalAssetValueByType('tangible');
    this.investor.total_retirement_assets_value = this.calculateTotalAssetValueByType('retirement');
    this.investor.total_personal_assets_value = this.calculateTotalAssetValueByType('personal');
    this.investor.total_marketable_assets_value = this.calculateTotalAssetValueByType('marketable_instruments');

    this.totalAssetValue = this.investor.assets.map(a => parseInt(a.value) || 0).reduce((val1, val2) => val1 + val2, 0);
    const la_fa_total = this.investor.total_financial_assets_value + this.investor.total_liquid_assets_value + this.investor.total_marketable_assets_value;
    this.investor.total_liquid_financial_assets_value = la_fa_total;
    const other_total = this.investor.total_tangile_assets_value + this.investor.total_retirement_assets_value + this.investor.total_personal_assets_value;
    this.investor.total_other_assets_value = other_total;
    // tslint:disable-next-line:max-line-length
    this.investor.liquid_financial_weighted_average = this.investor.assets.filter(a => a.asset_type === 'liquid' || a.asset_type === 'financial' || a.asset_type === 'marketable_instruments')
                                                      // tslint:disable-next-line:max-line-length
                                                      .map(a => ((parseInt(a.value) || 0) / la_fa_total) * 100 * (a.return_percentage))
                                                      .reduce((val1, val2) => val1 + val2, 0) / 100;
    // tslint:disable-next-line:max-line-length
    this.investor.other_assets_weighted_average = this.investor.assets.filter(a => a.asset_type === 'tangible' || a.asset_type === 'personal' || a.asset_type === 'retirement')
                                                      // tslint:disable-next-line:max-line-length
                                                      .map(a => ((parseInt(a.value) || 0) / other_total) * 100 * (a.return_percentage))
                                                      .reduce((val1, val2) => val1 + val2, 0) / 100;
  }

  calculateTotalAssetValueByType(type: string) {
    return this.investor.assets
                    .filter((a) => a.asset_type === type)
                    .map(a => parseInt(a.value) || 0)
                    .reduce((val1, val2) => val1 + val2, 0);
  }

  getAllocationForAsset(asset) {
    const assetValue = parseInt(asset.value) || 0;
    return asset.allocationPercentage = assetValue / this.totalAssetValue * 100;
  }

  getTotalOtherAssetsValue() {
    return this.investor.assets.filter(a => a.asset_type === 'tangible' || a.asset_type === 'personal' || a.asset_type === 'retirement')
                                                          .map(a => parseInt(a.value) || 0).reduce((val1, val2) => val1 + val2, 0);
  }

}

const availableAssetTypes = [
  {
    'type': 'liquid',
    'name': 'LIQUID ASSETS',
    'options':
    [
      {
        'name': 'SAVINGS A/C',
        'asset_type': 'liquid',
        'option_type': 'savings',
        'asset_allocation_type': 'cash',
        'return_percentage': 4
      },
      {
        'name': 'LIQUID FUNDS',
        'asset_type': 'liquid',
        'option_type': 'liquid_funds',
        'asset_allocation_type': 'cash',
        'return_percentage': 6
      },
      {
        'name': 'CASH ON HAND',
        'asset_type': 'liquid',
        'option_type': 'cash_on_hand',
        'asset_allocation_type': 'cash',
        'return_percentage': 0
      },
      {
        'name': 'OTHER LIQUID ASSETS',
        'asset_type': 'liquid',
        'option_type': 'other_liquid_assets',
        'asset_allocation_type': 'cash',
        'return_percentage': 6
      }
    ]
  },
  {
    'type': 'financial',
    'name': 'FINANCIAL ASSETS (Fixed Income)',
    'options':
    [
      {
        'name': 'BANK FD',
        'asset_type': 'financial',
        'option_type': 'bank_fd',
        'asset_allocation_type': 'debt',
        'return_percentage': 7
      },
      {
        'name': 'NBFC FD',
        'asset_type': 'financial',
        'option_type': 'nbfc_fd',
        'asset_allocation_type': 'debt',
        'return_percentage': 7.5
      },
      {
        'name': 'CORPORATE FD',
        'asset_type': 'financial',
        'option_type': 'corporate_fd',
        'asset_allocation_type': 'debt',
        'return_percentage': 8
      },
      {
        'name': 'POSTAL INSTRUMENTS',
        'asset_type': 'financial',
        'option_type': 'postal_instruments',
        'asset_allocation_type': 'debt',
        'return_percentage': 7
      },
      {
        'name': 'CASH VALUE OF LIFE INSURANCE POLICIES',
        'asset_type': 'financial',
        'option_type': 'cash_value_lic',
        'asset_allocation_type': 'debt',
        'return_percentage': 6
      },
      {
        'name': 'OTHERS FIXED INCOME PRODUCTS',
        'asset_type': 'financial',
        'option_type': 'other_fixed_income',
        'asset_allocation_type': 'debt',
        'return_percentage': 7.5
      }
    ]
  },
  {
    'type': 'marketable_instruments',
    'name': 'FINANCIAL ASSETS (Marketable Instruments)',
    'options':
    [
      {
        'name': 'INVESTMENT IN PRIVATE EQUITY',
        'asset_type': 'marketable_instruments',
        'option_type': 'investment_private_equity',
        'asset_allocation_type': 'equity',
        'return_percentage': 16
      },
      {
        'name': 'DIRECT EQUITY',
        'asset_type': 'marketable_instruments',
        'option_type': 'direct_equity',
        'asset_allocation_type': 'equity',
        'return_percentage': 15
      },
      {
        'name': 'EQUITY & HYBRID MUTUAL FUNDS SCHEMES',
        'asset_type': 'marketable_instruments',
        'option_type': 'mutual_funds_schemes',
        'asset_allocation_type': 'equity',
        'return_percentage': 14
      },
      {
        'name': 'EMPLOYEE STOCK OPTION PLAN ( ESOP)',
        'asset_type': 'marketable_instruments',
        'option_type': 'esop',
        'asset_allocation_type': 'equity',
        'return_percentage': 12
      },
      {
        'name': 'COMMODITIES',
        'asset_type': 'marketable_instruments',
        'option_type': 'commodity',
        'asset_allocation_type': 'comodities',
        'return_percentage': 12
      },
      {
        'name': 'PRECIOUS METALS (LIKE GOLD COINS, BARS, ETC)',
        'asset_type': 'marketable_instruments',
        'option_type': 'precious_metals',
        'asset_allocation_type': 'precious_metals',
        'return_percentage': 12
      },
      {
        'name': 'OTHER MARKETABLE INSTRUMENTS',
        'asset_type': 'marketable_instruments',
        'option_type': 'other_marketable_instruments',
        'asset_allocation_type': 'equity',
        'return_percentage': 11
      }
    ]
  },
  {
    'type': 'tangible',
    'name': 'TANGIBLE ASSETS',
    'options':
    [
      {
        'name': 'RESIDENTAL PLOT - LAND',
        'asset_type': 'tangible',
        'option_type': 'residential_plot_land',
        'asset_allocation_type': 'real_estate',
        'return_percentage': 6
      },
      {
        'name': 'OFFICE / SHOP',
        'asset_type': 'tangible',
        'option_type': 'office_shop',
        'asset_allocation_type': 'real_estate',
        'return_percentage': 5
      },
      {
        'name': 'VACATION HOME',
        'asset_type': 'tangible',
        'option_type': 'vacation_home',
        'asset_allocation_type': 'real_estate',
        'return_percentage': 3
      },
      {
        'name': 'OTHER PROPERTY LIKE ART, COINS AND STAMPS COLLECTIONS',
        'asset_type': 'tangible',
        'option_type': 'other_property_art_stamps_coins',
        'asset_allocation_type': 'other_assets',
        'return_percentage': 2
      }
    ]
  },
  {
    'type': 'personal',
    'name': 'PERSONAL ASSETS',
    'options':
    [
      {
        'name': 'PRIMARY HOUSE',
        'asset_type': 'personal',
        'option_type': 'primary_house',
        'asset_allocation_type': 'other_assets',
        'return_percentage': 7.5
      },
      {
        'name': 'CAR/VEHICLES',
        'asset_type': 'personal',
        'option_type': 'car_vehicles',
        'asset_allocation_type': 'other_assets',
        'return_percentage': 0
      },
      {
        'name': 'JEWELLERY',
        'asset_type': 'personal',
        'option_type': 'jewellery',
        'asset_allocation_type': 'other_assets',
        'return_percentage': 3
      },
      {
        'name': 'OTHER PERSONAL ASSETS - BELONGINGS',
        'asset_type': 'personal',
        'option_type': 'other_personal_assets_belongings',
        'asset_allocation_type': 'other_assets',
        'return_percentage': 3
      }
    ]
  },
  {
    'type': 'retirement',
    'name': 'RETIREMENT ASSETS',
    'options':
    [
      {
        'name': 'PROVIDENT FUND',
        'asset_type': 'retirement',
        'option_type': 'pf',
        'asset_allocation_type': 'debt',
        'return_percentage': 8.55
      },
      {
        'name': 'SUPER ANNUATION FUND',
        'asset_type': 'retirement',
        'option_type': 'super_annuation_fund',
        'asset_allocation_type': 'debt',
        'return_percentage': 8
      },
      {
        'name': 'GRATUITY',
        'asset_type': 'retirement',
        'option_type': 'gratuity',
        'asset_allocation_type': 'debt',
        'return_percentage': 2
      },
      {
        'name': 'PUBLIC PROVIDENT FUND - PPF',
        'asset_type': 'retirement',
        'option_type': 'ppf',
        'asset_allocation_type': 'debt',
        'return_percentage': 7.6
      },
      {
        'name': 'CASH VALUE OF PENSION PLAN',
        'asset_type': 'retirement',
        'option_type': 'cash_value_pension_plan',
        'asset_allocation_type': 'debt',
        'return_percentage': 7
      },
      {
        'name': 'OTHER RETIREMENT ASSETS',
        'asset_type': 'retirement',
        'option_type': 'other_retirement_assets',
        'asset_allocation_type': 'debt',
        'return_percentage': 7
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/asset-details/asset-tab/asset-tab.component.ts